export default __webpack_public_path__ + "pin-green_light.051f5e37.svg";